import { connect } from 'react-redux';
import View from './EducationView';
import MobileView from '../../MobileFinancialPlan/MobileEducation/MobileEducationView';
import { setReactCalibrationWidget } from '../FinancialPlanActions';
import {
  goalId as goalIdSelector,
  goalViewState as goalViewStateSelector,
} from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { getGoal } from '../FinancialPlanHelpers';
import * as financialPlanSelector from '../FinancialPlanSelector';
import { OVERVIEW } from '../Explanations/ExplanationsConst';

const mapStateToProps = (state, ownProps) => {
  const data = financialPlanSelector.data(state, ownProps);
  const goalId = goalIdSelector(state, ownProps);
  const goal = getGoal(data, goalId);
  const isGoalEducation = goal.GoalType === 'education';

  const selectedSection = goalViewStateSelector(state, ownProps).selectedSection || OVERVIEW;

  const educationAssumption = goal.GoalAssumptions;

  if (ownProps.isPrint) {
    return {
      goalId: ownProps.goal.GoalId,
      data,
      goalName: ownProps.goal.GoalName,
      chartTitle: ownProps.goal.GoalCharts[0].Title,
      chartData: ownProps.goal.GoalCharts[0].Data,
      calibration: financialPlanSelector.calibration(state, ownProps),
      hasGoal: true,
      selectedSection,
      educationAssumption,
    };
  }

  if (isGoalEducation) {
    return {
      goalId: goal.GoalId,
      data,
      goalName: goal.GoalName,
      chartTitle: goal.GoalCharts[0].Title,
      chartData: goal.GoalCharts[0].Data,
      calibration: financialPlanSelector.calibration(state, ownProps),
      hasGoal: isGoalEducation,
      selectedSection,
      educationAssumption,
    };
  }

  return {
    goalId: '',
    data,
    chartTitle: '',
    chartData: [],
    calibration: {},
    hasGoal: isGoalEducation,
    selectedSection,
    educationAssumption,
  };
};

const mapDispatchToProps = dispatch => ({
  setReactCalibrationWidget: (calibrationParams, clientId) => {
    dispatch(setReactCalibrationWidget(calibrationParams, clientId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
export const MobileEducation = connect(mapStateToProps, mapDispatchToProps)(MobileView);
